import { render, staticRenderFns } from "./counterpartiesModalArchive.vue?vue&type=template&id=045255e4&scoped=true"
import script from "./counterpartiesModalArchive.vue?vue&type=script&lang=js"
export * from "./counterpartiesModalArchive.vue?vue&type=script&lang=js"
import style0 from "./counterpartiesModalArchive.vue?vue&type=style&index=0&id=045255e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045255e4",
  null
  
)

export default component.exports